import { merge } from 'lodash';
import { normalize, schema } from 'normalizr';
import { combineReducers } from 'redux';

// Define a marutis schema
const marutiSchema = new schema.Entity('marutis', {}, { idAttribute: 'redisId' });
const marutiListSchema = [marutiSchema];

const defaultMarutiParams = {
  marutiFetched: false,
  searchFetched: false,
  createTitle: 'Create New Maruti',
  createSubmitButtonText: 'Create Maruti',
  editTitle: 'Edit Maruti',
  editSubmitButtonText: 'Edit Maruti'
}

//normalized object
function byId(state = {}, action) {
  if (action.type === 'FETCHED_MARUTI') {
    const normalizedMaruti = normalize(action.payload, marutiListSchema);
    return merge({}, normalizedMaruti.entities.marutis)
  }
  if (action.type === 'REPOST_REDISID') {
    console.log('appied job', action.payload)
    return {
      ...state,
      [action.payload]: {
        ...state[action.payload],
        postStatus: 1

      }
    }
  }
  if (action.type === 'RESET_DATA') {
    return {}
  } else {
    return state
  }

}

//array of object
function collection(state = [], action) {
  if (action.type === 'FETCHED_MARUTI') {
    return action.payload
  }
  if (action.type === 'SYNCED_UTD') {
    const { utd, msg } = action.payload || {}
    // Only flag as posted when the post actually succeeded (msg === "Done")
    const success = typeof msg === 'string' && msg.toLowerCase() === 'done'
    if (!utd || !success) return state
    return state.map(item =>
      String(item.UTD) === String(utd) ? { ...item, posted: 1 } : item
    )
  }
  if (action.type === 'RESET_DATA') {
    return []
  } else {
    return state
  }
}

function searchResults(state = {}, action) {
  if (action.type === 'STORE_SEARCH_MARUTI_RESULT') {
    const normalizedMaruti = normalize(action.payload, marutiListSchema);
    return merge({}, normalizedMaruti.entities.marutis)
  } else {
    return state
  }
}

function filterResults(state = {}, action) {
  if (action.type === 'FILTER_ITEMS') {
    const col = action.payload.col;
    return {
      ...state,
      [col]: action.payload
    }
  } else {
    return state
  }
}

function fetchedOldSyncStatus(state = "", action) {
  if (action.type === 'FETCHED_PULL_OLD_SYNC_STATUS') {
    // console.log(action.payload,'------acp')
    return action.payload
  }
  else {
    return state
  }
}



function params(state = defaultMarutiParams, action) {
  if (action.type === 'FETCHED_MARUTI') {
    return {
      ...state,
      marutiFetched: true,
      isFetching: false
    }
  } if (action.type === 'SEARCH_MARUTI') {
    return {
      ...state,
      searchFetched: false,
      isSearching: true,
    }
  }
  if (action.type === 'STORE_SEARCH_MARUTI_RESULT') {
    return {
      ...state,
      searchFetched: true,
      isSearching: false,
    }
  } if (action.type === 'SET_MARUTI_FETCH_OFF') {
    return {
      ...state,
      isDelFetched: false
    }
  }
  if (action.type === 'RESET_DATA') {
    return defaultMarutiParams
  } else {
    return state
  }
}

function notificationsPopup(state = {}, action) {
  if (action.type === "SYNCED_UTD") {
    return {
      ...state,
      type: {
        status: action.payload.msg.toLowerCase() === "done" ? "success" : "error",
        msg: "Successfully Posted!",
      },
    };
  }
  if (action.type === "NOTIFICATION_DONE_ITEM") {
    return {
      ...state,
      type: {
        status: "",
        msg: "",
      },
    };
  } else {
    return state;
  }
}

const txnsync = combineReducers({
  byId,
  collection,
  searchResults,
  params,
  filterResults,
  fetchedOldSyncStatus,
  notificationsPopup
});

export default txnsync;

